module.exports = "/images/vendor/flag-icon-css/flags/1x1/tm.svg?ea365f332bb0b8bb8f1fad69c2f4fcfc";